import { setDoc, doc } from "firebase/firestore";
import { db } from '../firebase.js';

export const DATE_WHEN_BLOCKS_AND_STEALS_WERE_ADDED = new Date('May 27, 2024');

// Fixed seed pairings for the first round of each conference's playoff
// bracket. A play-in game feeds into whichever matchup here has its
// "better" seed as the second seed (e.g. an 8v9 play-in game's winner
// becomes the 8 seed and plays in the 1v8 matchup). Shared between
// playoff generation (AdminSeasonPlayoffs.js) and bracket rendering
// (Bracket.js) so both stay in sync on the same seed structure.
export const PLAYOFF_FIRST_ROUND_MATCHUPS = [
  [2, 7],
  [3, 6],
  [4, 5],
  [1, 8]
];

// The first-round matchup index (0-based) a play-in game's winner
// advances into, based on the "better" seed in the play-in matchup.
export function getPlayInSlotIndex (game) {
  const matchupTag = (game.playoffTags || []).find(tag => /^\d+vs\d+$/.test(tag));
  if (!matchupTag) return -1;

  const betterSeed = parseInt(matchupTag.split('vs')[0]);
  return PLAYOFF_FIRST_ROUND_MATCHUPS.findIndex(([, worseSeed]) => worseSeed === betterSeed);
}

// League Constants
export function playoffsStarted (league, season) {
  if (league.games.length == 0) {
    return false;
  }

  return regularSeasonDone(league, season)
}
export function playoffTeamsFinalized () {
  return false;
}
function regularSeasonDone (league, season) {
  const regularSeasonGames = league.games.filter((game) => game.season == season && game.type == 'regular_season')
  if (regularSeasonGames.length == 0) {
    return false;
  } 

  const unfinishedRegularSeasonGameCount = regularSeasonGames.filter((game) => !['completed', 'cancelled'].includes(game.status)).length
  return unfinishedRegularSeasonGameCount == 0;
}
export function getCurrentPlayoffRound () {
  return 'play-in';
}

export function getGamesPerTeamForSeason (season) {
  switch (season) {
    case '1':
      return 0;
    case '2':
      return 0;
    case '3':
      return 15;
    case '4':
      return 8;
    case '5':
      return 12;
    case '6':
      return 8;
  }
}

export function showSeasonLeaders (games, seasonTeams) {
  if (games.length == 0) {
    return false;
  }

  const completedGames = games.filter((game) => ['completed'].includes(game.status))
  return completedGames.length > 1;
}
export function getLastSeason (currentSeason) {
  return parseInt(currentSeason) - 1;
}
export function toRomanNumeral (num) {
  const vals = [1000,900,500,400,100,90,50,40,10,9,5,4,1];
  const syms = ['M','CM','D','CD','C','XC','L','XL','X','IX','V','IV','I'];
  let result = '';
  for (let i = 0; i < vals.length; i++) {
    while (num >= vals[i]) {
      result += syms[i];
      num -= vals[i];
    }
  }
  return result;
}

export function getCurrentOrMostRecentSeasonStartDate () {
  // Season 5
  return new Date('October 24, 2025');
  // Season 4
  // return new Date('June 8, 2025');
  // Season 3
  // return new Date('October 15, 2024');
  // Season 2
  // return new Date('May 13, 2024');
}
export function getUpcomingSeasonStartDate () {
  return new Date('October 24, 2025');
}


export function createNewIDForGame () {
  let dateString = Date.now().toString(36);
  let randomness = Math.random().toString(36).substr(2);
  let gameID = dateString + randomness;

  return gameID;
}

export function getLocationName (location, abbv=false) {
  if (location == 'sbca') {
    if (abbv) {
      return 'SBCA'
    } else {
      return "South Boston Catholic Academy"
    }
  } else if (location == 'b&gc') {
    if (abbv) {
      return "B&GC"
    } else {
      return "Boys & Girls Club"
    }
  } else if (location == 'jpt-school') {
    if (abbv) {
      return 'TYNAN'
    } else {
      return 'Joseph P. Tynan School'
    }
  } else if (location == 'condon') {
    if (abbv) {
      return 'CONDON'
    } else {
      return 'Condon School'
    }
  } else {
    if (abbv) {
      return 'SBCA'
    } else {
      return "South Boston Catholic Academy"
    }
  }
}

export function displayTeamConference (team) {
  if (team.conference == 'west') {
    return 'Western Conference'
  } else if (team.conference == 'east') {
    return 'Eastern Conference'
  }
}

// Data Access - General
export function getTeamForID(teams, id) {
  return teams.find((team) => team.id == id || team.team_id == id || team.teamID == id);
}
export function getCurrentTeamForPlayerID (teams, playerID) {
  return teams.find((team) => team.players?.includes(playerID))
}
export function getGameForID (games, id) {
  return games.find((game) => game.id == id);
}
export function getPlayerByID(players, id) {
  return players.find((player) => player.id == id);
}

// Data Access - Games
function getCompletedRegularSeasonGamesBySeason (games, season) {
  return games.filter((game) => ['completed'].includes(game.status) && game.season == season && game.type == 'regular_season')
}

// Database, Admin, etc.
export function getDatabaseSource () {
  return `league_morning_star_2`;
}

// Interpolated Team Data
export function getRecordForID (games, teamID, season) {
  games = games.filter((game) => game.type == 'regular_season')
  if (teamID) {
    let allGames = games.filter((game) => game.status === 'completed' && game.season.toString() == season && (game.awayTeamID === teamID || game.homeTeamID === teamID))
    let allGamesWon = allGames.filter((game) => game.winner === teamID)
    let gamesPlayed = allGames.length;
    let gamesWon = allGamesWon.length;
    return `${gamesWon}-${gamesPlayed - gamesWon}`
  } else {
    return '';
  }
}

// Interpolated Player Data
export function displayPlayerName (player) {
  if (player.first_name && player.last_name) {
    return `${player.first_name} ${player.last_name.replace("’", "'")}`
  } else {
    return `${player.firstName} ${player.lastName.replace("’", "'")}`
  }
}
export function displayPlayerHeight (player) {
  const height = player.height
  return `${height.feet}' ${height.inches}"`
}
export function displayJerseyNumber (player) {
  if (player.jerseyNumber == '') {
    return ``
  }
  return `#${player.jerseyNumber}`
}

// Miscallaneous
export function abbvWeekday (idx) {
  let weekday = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  return weekday[idx];
}

export function isAdminEmail (email) {
  let adminEmails = [
    'ccrane2@alumni.nd.edu',
    'chandlercharlescrane@gmail.com',
    'matthew.chignoli@gmail.com',
    'frpeterschirripa@gmail.com'
  ]

  return adminEmails.includes(email)
}

// Homepage helpers
export function getUpcomingGames(games, season) {
  const today = Date.now();
  const threeDaysAgo = today - (3 * 24 * 60 * 60 * 1000);
  const twoWeeks = today + (14 * 24 * 60 * 60 * 1000);

  return games.filter(game =>
    !['postponed'].includes(game.status) && (
      // Recently completed (past 3 days)
      (game.status === 'completed' && game.date > threeDaysAgo && game.date <= today) ||
      // Upcoming (next 2 weeks, not completed)
      (game.status !== 'completed' && game.date > today && game.date < twoWeeks)
    )
  );
}

export function getSeasonTeams(games, teams, season) {
  const rankedTeams = rankTeams(games, teams, season);

  let seasonTeams = [];

  let eastSeed = 1;
  let westSeed = 1;
  let seed;

  rankedTeams.forEach((team, place) => {
    if (team.conference === 'east') {
      seed = eastSeed++;
    } else {
      seed = westSeed++;
    }

    seasonTeams.push({
      'id': team.id,
      'name': team.name,
      'nameAbbv': team.nameAbbv,
      'place': place + 1,
      'seed': seed,
      'conference': team.conference || '',
      'wins': team.stats.wins,
      'losses': team.stats.losses,
      'winPercentage': displayWinPercentage(team.stats),
      'pointsFor': team.stats.pointsFor,
      'pointsAgainst': team.stats.pointsAgainst,
      'streak': displayStreak(team.stats.streak)
    })
  });

  return seasonTeams;
}

function displayWinPercentage (stats) {
  if (stats.wins + stats.losses == 0) {
    return '-';
  }

  if (stats.wins > 0 && stats.losses == 0) {
    return '1.000';
  }

  return (stats.wins / (stats.wins + stats.losses)).toFixed(3).toString().slice(1)
}

function displayStreak (streak) {
  if (streak === 0) {
    return '-';
  }
  else if (streak < 0) {
    return Math.abs(streak).toString() + 'L'
  } else {
    return streak.toString() + 'W'
  }
}

function getStatsForTeams (games, teams, season) {
  let teamData = {};
  teams.forEach((team) => teamData[team.id] = {
    wins: 0,
    losses: 0,
    games: 0,
    streak: 0,
    pointsAgainst: 0,
    pointsFor: 0
  })

  let completedGames = getCompletedRegularSeasonGamesBySeason(games, season);

  let sortedCompletedGames = completedGames.sort((a, b) => (a.date < b.date) ? -1 : 1)
  sortedCompletedGames.forEach((game) => {
    let winner = game.winner;
    let loser = game.winner == game.awayTeamID ? game.homeTeamID : game.awayTeamID;

    let winnerScore = game.score.away > game.score.home ? game.score.away : game.score.home;
    let loserScore = game.score.away > game.score.home ? game.score.home : game.score.away;

    if (teamData[winner]) {
      teamData[winner].wins += 1;
      teamData[winner].games += 1;
      teamData[winner].pointsAgainst += loserScore;
      teamData[winner].pointsFor += winnerScore;
      if (teamData[winner].streak < 0) {
        teamData[winner].streak = 1;
      } else {
        teamData[winner].streak += 1;
      }
    }

    if (teamData[loser]) {
      teamData[loser].losses += 1;
      teamData[loser].games += 1;
      teamData[loser].pointsAgainst += winnerScore;
      teamData[loser].pointsFor += loserScore;
      if (teamData[loser].streak > 0) {
        teamData[loser].streak = -1;
      } else {
        teamData[loser].streak -= 1;
      }
    }
  })

  let defaultStats =  {
    pointsFor: '0',
    pointsAgainst: '0',
    streak: '-',
    wins: '0',
    losses: '0',
    games: '0',
    winPercentage: '.000',
    winPercentageValue: 0
  };

  let newTeamList = [];
  teams.forEach((team) => {
    let t = teamData[team.id];
    if (t.wins === t.games && t.games > 0) {
      t.winPercentage = '1.000';
      t.winPercentageValue = 1;
    } else if(t.wins + t.losses !== 0){
      t.winPercentage = (t.wins / t.games).toFixed(3).toString().slice(1);
      t.winPercentageValue = t.wins / t.games
    }

    let existingTeamData = team;
    let stats = {...defaultStats, ...teamData[team.id]};
    existingTeamData.stats = stats;

    newTeamList.push(existingTeamData);
  })

  return newTeamList;
}

// function rankTeamsByConference(games, teams, season) {
//   let sortedTeams = teams.sort((a, b) => {
//     // Ranking by Win Percentage
//     if (a.stats.winPercentageValue > b.stats.winPercentageValue) { // .321 team > .123 team
//       return -1;
//     } else if (a.stats.winPercentageValue < b.stats.winPercentageValue) { // .123 team < .321 team
//       return 1;
//     } else if (a.stats.losses > b.stats.losses) { // 0-1 teams > 0-2 teams
//       return 1;
//     } else if (a.stats.losses < b.stats.losses) { // 0-2 teams < 0-1 teams
//       return -1;
//     } else if (a.stats.games > b.stats.games) { // 2-0 teams > 1-0 teams
//       return -1;
//     } else if (a.stats.games < b.stats.games) { // 1-0 teams < 2-0 teams
//       return 1;
//     } else {
//       // Tiebreaker #1 - Head to Head
//       let headToHead = headToHeadValue(games, season, a, b);
//       if (headToHead !== 0) {
//         return headToHead;
//       } else {
//         // Tiebreaker #2 - Point Differential +/-
//         let pointDifferentialTeamA = a.stats.pointsFor - a.stats.pointsAgainst;
//         let pointDifferentialTeamB = b.stats.pointsFor - b.stats.pointsAgainst;
//         if (pointDifferentialTeamA > pointDifferentialTeamB) {
//           return -1;
//         } else if (pointDifferentialTeamA < pointDifferentialTeamB) {
//           return 1;
//         } else {
//           return 0;
//         }
//       }
//     }
//   })

//   return sortedTeams;
// }

// RANKING SYSTEM LOGIC START

export function rankTeamsByConference(games, teams, season) {
  // 1️⃣ Sort ONLY by record (no tiebreakers)
  const recordSorted = [...teams].sort(compareByRecord);

  // 2️⃣ Walk the sorted list and resolve tied blocks
  const finalStandings = [];

  let i = 0;
  while (i < recordSorted.length) {
    const tiedGroup = [recordSorted[i]];
    let j = i + 1;

    while (
      j < recordSorted.length &&
      haveSameRecord(recordSorted[i], recordSorted[j])
    ) {
      tiedGroup.push(recordSorted[j]);
      j++;
    }

    if (tiedGroup.length === 1) {
      finalStandings.push(tiedGroup[0]);
    } else {
      finalStandings.push(
        ...resolveTieGroup(games, season, tiedGroup)
      );
    }

    i = j;
  }

  return finalStandings;
}

/* ------------------------------------------------------------------ */
/* Comparators & Helpers                                              */
/* ------------------------------------------------------------------ */

function compareByRecord(a, b) {
  const aPlayed = a.stats.games > 0;
  const bPlayed = b.stats.games > 0;
  if (aPlayed !== bPlayed) return aPlayed ? -1 : 1;

  if (a.stats.winPercentageValue !== b.stats.winPercentageValue) {
    return b.stats.winPercentageValue - a.stats.winPercentageValue;
  }

  if (a.stats.losses !== b.stats.losses) {
    return a.stats.losses - b.stats.losses;
  }

  if (a.stats.games !== b.stats.games) {
    return b.stats.games - a.stats.games;
  }

  return 0;
}

// Used only for the cross-conference merge — adds point differential as a
// tiebreaker so teams with the same record interleave by diff instead of
// always putting east first.
function compareForMerge(a, b) {
  const cmp = compareByRecord(a, b);
  if (cmp !== 0) return cmp;
  const aDiff = (a.stats.pointsFor || 0) - (a.stats.pointsAgainst || 0);
  const bDiff = (b.stats.pointsFor || 0) - (b.stats.pointsAgainst || 0);
  return bDiff - aDiff;
}

function haveSameRecord(a, b) {
  return (
    a.stats.winPercentageValue === b.stats.winPercentageValue &&
    a.stats.losses === b.stats.losses &&
    a.stats.games === b.stats.games
  );
}

function resolveTieGroup(games, season, tiedTeams) {
  // 2-team tie → keep your original head-to-head
  if (tiedTeams.length === 2) {
    const [a, b] = tiedTeams;
    const h2h = headToHeadValue(games, season, a, b);
    if (h2h !== 0) return h2h < 0 ? [a, b] : [b, a];
    return sortByPointDifferential(tiedTeams);
  }

  // 3+ team tie → win percentage among tied teams
  const winPctAmongTied = new Map();

  tiedTeams.forEach(team => {
    // games this team played vs others in tied group
    const gamesVsTied = games.filter((g) => g.status === 'completed' && g.season === season && g.type === 'regular_season' && tiedTeams.some(t => t.id === g.homeTeamID || t.id === g.awayTeamID) &&(g.homeTeamID === team.id || g.awayTeamID === team.id));

    const wins = gamesVsTied.filter(game => game.winner === team.id).length;
    const total = gamesVsTied.length;
    winPctAmongTied.set(team.id, total === 0 ? 0 : wins / total);
  });

  // sort by win percentage among tied teams
  const sorted = [...tiedTeams].sort(
    (a, b) => winPctAmongTied.get(b.id) - winPctAmongTied.get(a.id)
  );

  // If still tied → fallback to point differential
  const uniquePcts = new Set(sorted.map(t => winPctAmongTied.get(t.id)));
  if (uniquePcts.size === 1) {
    return sortByPointDifferential(sorted);
  }

  return sorted;
}



function sortByPointDifferential(teams) {
  return [...teams].sort((a, b) => {
    const diffA = a.stats.pointsFor - a.stats.pointsAgainst;
    const diffB = b.stats.pointsFor - b.stats.pointsAgainst;

    if (diffA !== diffB) {
      return diffB - diffA;
    }

    return 0;
  });
}


// RANKING SYSTEM LOGIC END

function rankTeams (games, teams, season) {
  let teamsWithStats = getStatsForTeams(games, teams, season);

  const eastTeams = teamsWithStats.filter((t) => t.conference == 'east')
  const westTeams = teamsWithStats.filter((t) => t.conference == 'west')

  // If no teams have conferences assigned yet, rank everyone together
  if (eastTeams.length === 0 && westTeams.length === 0) {
    return rankTeamsByConference(games, teamsWithStats, season);
  }

  const sortedEastTeams = rankTeamsByConference(games, eastTeams, season)
  const sortedWestTeams = rankTeamsByConference(games, westTeams, season)

  const semiSortedLeagueTeams = [];

  let eI = 0;
  let wI = 0;

  while (eI < sortedEastTeams.length || wI < sortedWestTeams.length) {
    if (eI >= sortedEastTeams.length) {
      semiSortedLeagueTeams.push(sortedWestTeams[wI++]);
    } else if (wI >= sortedWestTeams.length) {
      semiSortedLeagueTeams.push(sortedEastTeams[eI++]);
    } else {
      const cmp = compareForMerge(sortedEastTeams[eI], sortedWestTeams[wI]);
      if (cmp <= 0) {
        semiSortedLeagueTeams.push(sortedEastTeams[eI++]);
      } else {
        semiSortedLeagueTeams.push(sortedWestTeams[wI++]);
      }
    }
  }

  return semiSortedLeagueTeams;
}

function headToHeadValue (games, season, a, b) {
  let gamesAgainstEachother = games.filter((game) => game.status == 'completed' && game.season == season && game.type == 'regular_season' && ((game.awayTeamID == a.id && game.homeTeamID == b.id) || (game.awayTeamID == b.id && game.homeTeamID == a.id)))
  let gamesTeamAWon = gamesAgainstEachother.filter((game) => game.winner == a.id)

  if (gamesAgainstEachother.length == 0) {
    return 0;
  } else if (gamesTeamAWon.length / gamesAgainstEachother.length < .5) {
    return 1;
  } else if (gamesTeamAWon.length / gamesAgainstEachother.length > .5) {
    return -1;
  } else {
    return 0;
  }
}

export function getSeasonLeaders(games, teams, players, gameStats, season, leaderCount) {
  const currentPlayers = getCurrentPlayers(teams, players)
  const statLabels = ['points', 'rebounds', 'assists', 'blocks', 'steals'];

  let leaders = []

  for (const statLabel of statLabels) {
    let playerAverages = []
    currentPlayers.forEach((p) => {
      let allStatsForPlayer;
      let withStealsAndBlocks = true;
      if (statLabel !== 'blocks' && statLabel !== 'steals') {
        withStealsAndBlocks = false;
      }
      allStatsForPlayer = getStatsForPlayer(games, gameStats, p.id, season, withStealsAndBlocks);


      if (allStatsForPlayer.length == 0) {
        return;
      }

      let average = 0;

      const playedGamesStats = allStatsForPlayer.filter((stat) => stat.status == 'played');
      const dnpGamesStats = allStatsForPlayer.filter((stat) => stat.status == 'dnp');

      if (playedGamesStats.length <= dnpGamesStats.length)  {
        average = 0;
      } else {
        average = playedGamesStats.reduce(function (avg, player, _, { length }) {

          return avg + player[statLabel] / length;
        }, 0);
      }

      let playerAverage = {
        'id': p.id,
        'name': displayPlayerName(p),
        'average': average
      };
      if (!isNaN(average)) {
        playerAverages.push(playerAverage)
      }
    })

    let topPlayerAverages = playerAverages.sort((function(a,b){
      return a.average > b.average ? -1 : 1;
    })).slice(0, leaderCount);

    for (const player of topPlayerAverages) {
      let team = getCurrentTeamForPlayerID(teams, player.id)

      leaders.push(
        {
          'id': player.id,
          'stat': statLabel,
          'name': player.name,
          'teamName': team.name,
          'value': player.average
        }
      )
    }
  }

  return leaders;
}

function getStatsForPlayer (games, gameStats, playerID, season, withStealsAndBlocks, onlyGamesPlayed) {
  let allStatsForPlayer;
  if (withStealsAndBlocks) {
    allStatsForPlayer = gameStats.filter((gameStat) => gameStat.playerID == playerID && getGameForID(games, gameStat.gameID).date > DATE_WHEN_BLOCKS_AND_STEALS_WERE_ADDED)
  } else {
    allStatsForPlayer = gameStats.filter((gameStat) => gameStat.playerID == playerID)
  }

  if (onlyGamesPlayed) {
    allStatsForPlayer = allStatsForPlayer.filter((gameStat) => gameStat.status !== 'played');
  }

  if (season == 0) {
    return allStatsForPlayer;
  } else {
    return allStatsForPlayer.filter((stats) => getGameForID(games, stats.gameID).season == season)
  }
}

export function getCurrentPlayers (teams, players) {
  let currentPlayers = teams.map((team) => team.players.map((id) => getPlayerByID(players, id))).flat()
  // Known limitation - there are a few players who have stats but are not in the players table
  // They cannot show up in the top season stats. This if fine because they don't anyways.
  // In the future, we may want to allow this or just create player entries for them.
  return currentPlayers.filter((p) => p !== undefined)
}

export function formatDateInputValue (date) {
  if (!(date instanceof Date) || isNaN(date)) return '';

  const local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return local.toISOString().slice(0, 16); // 'YYYY-MM-DDTHH:mm'
};


export function formatDraftTime(isoString) {
  if (!isoString) return '';
  const date = new Date(isoString);
  const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  const dayOfWeek = days[date.getDay()];
  const month = date.getMonth() + 1;
  const day = date.getDate();
  let hours = date.getHours();
  const minutes = date.getMinutes().toString().padStart(2, '0');
  const ampm = hours >= 12 ? 'PM' : 'AM';
  hours = hours % 12;
  if (hours === 0) hours = 12;
  return `${dayOfWeek} ${month}/${day} ${hours}:${minutes} ${ampm}`;
}

export function generateTimeSlotsFromSchedule(schedule) {
  if (!schedule || !schedule.days || schedule.days.length === 0) return [];
  const { pickIntervalMinutes = 60, days } = schedule;
  const times = [];
  for (const day of days) {
    const { date, startTime, endTime } = day;
    if (!date || !startTime || !endTime) continue;
    let current = new Date(`${date}T${startTime}:00`);
    const end = new Date(`${date}T${endTime}:00`);
    while (current <= end) {
      times.push(new Date(current).toISOString());
      current = new Date(current.getTime() + pickIntervalMinutes * 60000);
    }
  }
  return times;
}


export function getAgeForBirthday (birthday, givenAge=null) {
  if (!birthday || birthday.year === '' || parseInt(birthday.year) > 2008) {
    return givenAge
  }

  const today = new Date();
  const birthDate = new Date(birthday.year, birthday.month - 1, birthday.day); 
  // month - 1 because JS months are 0-based

  let age = today.getFullYear() - birthDate.getFullYear();
  const hasHadBirthdayThisYear =
    today.getMonth() > birthDate.getMonth() ||
    (today.getMonth() === birthDate.getMonth() && today.getDate() >= birthDate.getDate());

  if (!hasHadBirthdayThisYear) {
    age--;
  }

  return age;
}

export function seasonTeamID (team_id, season) {
  return team_id + '-' + season
}

export function getTimeAgo(timestamp) {
  const now = Date.now();
  const date = timestamp.toDate ? timestamp.toDate() : new Date(timestamp);
  const secondsAgo = Math.floor((now - date.getTime()) / 1000);

  if (secondsAgo < 604800) {
    if (secondsAgo < 2) return 'Just now';
    if (secondsAgo < 60) return `${secondsAgo}s ago`;
    if (secondsAgo < 3600) return `${Math.floor(secondsAgo / 60)}m ago`;
    if (secondsAgo < 86400) return `${Math.floor(secondsAgo / 3600)}h ago`;
    return `${Math.floor(secondsAgo / 86400)}d ago`;
  }

  const options = { year: 'numeric', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric' };
  return date.toLocaleDateString(undefined, options);
}
